import { Text } from "@mantine/core"
import { IconDownload } from "@tabler/icons-react"
import { BaseSyntheticEvent } from "react"

import { ActionIcon } from "../../atoms/ActionIcons/ActionIcon"

type Props = {
  documentName: string
  showAsText?: boolean
  customText?: string
  filename?: string
  fetchDownloadUrl: () => Promise<string | undefined>
}
export function DocumentDownload({
  documentName,
  showAsText,
  customText,
  fetchDownloadUrl,
}: Props) {
  const handleDownloadDocument = async (e: BaseSyntheticEvent) => {
    e.stopPropagation()
    const downloadUrl = await fetchDownloadUrl()
    if (!downloadUrl) {
      throw new Error("No download URL found")
    }
    download(downloadUrl)
  }

  const download = (url: string) => {
    const element = document.createElement("a")
    element.href = url
    element.download = documentName.endsWith(".pdf")
      ? documentName
      : `${documentName}.pdf`

    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)
    URL.revokeObjectURL(url)
  }

  return showAsText ? (
    <Text fz="sm" onClick={handleDownloadDocument}>
      {customText ? customText : "Download"}
    </Text>
  ) : (
    <ActionIcon icon={<IconDownload />} onClick={handleDownloadDocument} />
  )
}
